import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PauseIcon, PlayIcon, ZoomInIcon, XIcon } from "lucide-react";
import { Section, Reveal, Eyebrow } from "./ui";
import { previews } from "./data";
const tags = ["Mapas", "Rutinas", "Guías", "Tablas"];
export function PreviewGallery() {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [playing, setPlaying] = useState(true);
  useEffect(() => {
    if (!playing || zoom) return;
    const timer = window.setInterval(() => {
      setActive(current => (current + 1) % previews.length);
    }, 4200);
    return () => window.clearInterval(timer);
  }, [playing, zoom]);
  return <Section id="previsualizacion" className="bg-[#f6f9fd]" data-id="element-203" data-mp="nn597cak64is">
      <Reveal className="text-center" data-id="element-204" data-mp="2uc1ogq63s51i">
        <Eyebrow data-id="element-205" data-mp="2ud33t6u5jdp1">Previsualización real</Eyebrow>
        <h2 className="mx-auto max-w-lg font-serif-display text-3xl font-semibold leading-tight text-[var(--ink)] sm:text-4xl" data-id="element-206" data-mp="2pd8cj26gsm3g">
          No son promesas: mirá lo que vas a poder consultar.
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-207" data-mp="2p1qekbmz48b">
          Material claro, visual y pensado para abrir justo cuando necesitás una respuesta.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-208" data-mp="cel99pzcmy36">
          {tags.map(tag => <span key={tag} className="rounded-full bg-white px-3 py-1.5 text-xs font-bold text-[var(--accent)] shadow-sm" data-id="element-209" data-mp="ggotp43zxd0l">
              {tag}
            </span>)}
        </div>
      </Reveal>

      <Reveal delay={0.1} data-id="element-210" data-mp="qe31kfbustha">
        <div className="mx-auto mt-6 max-w-[280px] sm:mt-9 sm:max-w-sm" data-id="element-211" data-mp="qfxmvur1enlw">
          <div className="relative overflow-hidden rounded-2xl border-4 border-white bg-white p-1.5 shadow-[0_20px_45px_-25px_rgba(31,51,69,0.45)] sm:rounded-[1.75rem] sm:p-2" data-id="element-212" data-mp="ve8wc4df6w3l">
            <div className="relative aspect-[4/5] overflow-hidden rounded-[1rem] bg-[#edf4fc] sm:aspect-[3/4] sm:rounded-[1.25rem]" data-id="element-213" data-mp="2x52ijahwybkk">
              <AnimatePresence mode="wait" data-id="element-214" data-mp="2p5foh6n3fi3j">
                <motion.img key={previews[active].src} src={previews[active].src} alt={previews[active].label} initial={{
                opacity: 0,
                scale: 1.035
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 0.98
              }} transition={{
                duration: 0.45,
                ease: "easeOut"
              }} className="h-full w-full cursor-zoom-in object-contain" onClick={() => setZoom(true)} loading="lazy" data-id="element-215" data-mp="2p6h2njzeokph" />
              </AnimatePresence>
              <button onClick={() => setZoom(true)} className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-white/95 text-[var(--ink)] shadow-md" aria-label="Ampliar muestra" data-id="element-216" data-mp="3hv4ophrzbe43">
                <ZoomInIcon className="h-4 w-4" aria-hidden data-id="element-217" data-mp="3mtprnoym8bw8" />
              </button>
            </div>
          </div>

          <div className="mt-3 flex items-center justify-center gap-2 sm:mt-4 sm:gap-3" data-id="element-218" data-mp="98yejp8okqci">
            <button onClick={() => setPlaying(value => !value)} className="flex h-9 w-9 items-center justify-center rounded-full border border-[#d8e6f4] bg-white text-[var(--accent)] shadow-sm" aria-label={playing ? "Pausar carrusel" : "Reanudar carrusel"} data-id="element-219" data-mp="e9coxdxr8cdp">
              {playing ? <PauseIcon className="h-3.5 w-3.5" aria-hidden data-id="element-220" data-mp="3mo4juudg1iys" /> : <PlayIcon className="h-3.5 w-3.5" aria-hidden data-id="element-221" data-mp="3rhfrgxq2y3rr" />}
            </button>
            <p className="max-w-[220px] text-center text-xs font-bold leading-snug text-[var(--ink)]" data-id="element-222" data-mp="3dq2a9qfn9hzw">
              {previews[active].label}
            </p>
          </div>

          <div className="mt-4 flex justify-center gap-1.5" aria-label="Progreso del carrusel" data-id="element-223" data-mp="33rd1qo9n19wb">
            {previews.map((preview, index) => <button key={preview.src} onClick={() => setActive(index)} className={`h-1.5 rounded-full transition-all ${index === active ? "w-5 bg-[var(--accent)]" : "w-1.5 bg-[#cdd9e4]"}`} aria-label={`Ver muestra ${index + 1}`} data-id="element-224" data-mp="38ov41vt5gqvc" data-mpi={index} />)}
          </div>
          <p className="mt-3 text-center text-[11px] font-medium text-[var(--muted)]" data-id="element-225" data-mp="63jstqnerge9">
            Avanza automáticamente · Tocá la imagen para ampliar
          </p>
        </div>
      </Reveal>

      <AnimatePresence data-id="element-226" data-mp="3saqdab35zh58">
        {zoom && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setZoom(false)} className="fixed inset-0 z-[70] flex items-center justify-center bg-[var(--ink)]/85 p-5 backdrop-blur-sm" data-id="element-227" data-mp="3ncyldh2irv11">
            <button onClick={() => setZoom(false)} className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white text-[var(--ink)] shadow-lg" aria-label="Cerrar ampliación" data-id="element-228" data-mp="1hk0a7piiw73r">
              <XIcon className="h-5 w-5" aria-hidden data-id="element-229" data-mp="1p4awlsrlv2d6" />
            </button>
            <motion.img key={previews[active].src} src={previews[active].src} alt={previews[active].label} initial={{
          scale: 0.94
        }} animate={{
          scale: 1
        }} className="max-h-[88vh] max-w-full rounded-xl bg-white object-contain shadow-2xl" data-id="element-230" data-mp="1p27uwbh3bksm" />
          </motion.div>}
      </AnimatePresence>
    </Section>;
}